import React from 'react';
import Flagship from '../../core/flagship';
import '../../styles/singleRecord.scss';
import { Label, Image, Popup, Grid } from 'semantic-ui-react';

const SingleRecordHeader = (props) => {

    const renderCreator = () => {
        let creatorName = (
            props.creatorFirstName !== null &&
            props.creatorLastName !== null ) ?
                props.creatorFirstName + ' ' +
                props.creatorLastName :
                    "Unknown";

        let creatorPhoto = ( props.creatorPhoto !== null && props.creatorPhoto !== '' ) ?
            props.creatorPhoto :
            "someone.png";

        return (
            <Popup
                trigger={<Image className="record-meta-creator-photo" src={Flagship.config.uploads + creatorPhoto} alt={creatorName} />}
                content={creatorName}
                position="bottom right"
            />
        )
    };

    let recordType = props.recordType;
    let recordStatus = props.recordStatus;
    let statusColor = "teal";
    let statusLabel = "New";

    if (recordStatus !== "new") {
        statusColor = Flagship.config.records[recordType].statuses[recordStatus].color;
        statusLabel = Flagship.config.records[recordType].statuses[recordStatus].label;
    }

    let viewTitle = props.recordName;
    if (recordType !== "client" && typeof props.recordKey !== "undefined") {
        viewTitle = '#' + props.recordKey + ' - ' + viewTitle;
    }

    return (
        <div id="view-header-section">
            <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8} largeScreen={8} widescreen={9} width={16}>
                    <h1 className="view-title">{viewTitle}</h1>

                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8} largeScreen={8} widescreen={7} width={16}>
                    <Label.Group className="record-meta" size='large'>

                        <Label className="meta-creator" image>
                            {renderCreator()}
                            <Label.Detail>Creator</Label.Detail>
                        </Label>

                        <Label image color="grey">
                            {props.recordMarket}
                            <Label.Detail>Market</Label.Detail>
                        </Label>

                        <Label image
                               color={statusColor}>
                            {statusLabel}
                            <Label.Detail>Status</Label.Detail>
                        </Label>
                    </Label.Group>
                </Grid.Column>
            </Grid>
        </div>
    )
};


export default SingleRecordHeader


// WEBPACK FOOTER //
// ./src/components/records/SingleRecordHeader.js